import MainLogo from './mainlogo.png';

import SideBarOpen from './mainlogo.png'
import SideBarClosed from './smalllogo.svg'

import dashboad from './dashboad.png'

import LoginBanner from './sales.jpg'

export const assets = {
  MainLogo, dashboad, SideBarOpen, SideBarClosed, LoginBanner
};